import { BooleanColumn, CategoricalColumn, CustomColumn, NumericalColumn } from 'baseui/data-table';
import { EMPTY_ARRAY } from 'commons-ui';
import { EMPTY_STRING } from 'commons/constants/immutable';

export const COL_NAMES = {
	segmentName: 'segmentName',
	bucketSupportedList: 'bucketSupportedList',
	conversionCoolOfPeriodHours: 'conversionCoolOfPeriodHours',
	conversionMinWithdrawalLimit: 'conversionMinWithdrawalLimit',
	conversionMaxWithdrawalLimit: 'conversionMaxWithdrawalLimit',
	withdrawalCoolOfPeriodHours: 'withdrawalCoolOfPeriodHours',
	minWithdrawalLimit: 'minWithdrawalLimit',
	maxWithdrawalLimit: 'maxWithdrawalLimit',
	withdrawalWithdrawFee: 'segmentName',
	globalCoolOfPeriodInHours: 'globalCoolOfPeriodsInHours',
	minimumCommonCoolOffPeriodInHours: 'minimumCommonCoolOffPeriodInHours',
	enableMinimumCoolOffFlow: 'enableMinimumCoolOffFlow',
	expName: 'expName',
	withdrawalFeeMaxValue: 'withdrawalFeeMaxValue'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.segmentName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CategoricalColumn({
		title: 'Experiment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.expName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	CustomColumn({
		title: 'Bucket Supported List',
		mapDataToValue: (data: any) => (data[COL_NAMES.bucketSupportedList] || EMPTY_ARRAY).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	BooleanColumn({
		title: 'Common Cool Off Period Flag',
		mapDataToValue: (data: any) => data[COL_NAMES.enableMinimumCoolOffFlow],
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Common Cool Off Period(Hrs)',
		mapDataToValue: (data: any) => data[COL_NAMES.minimumCommonCoolOffPeriodInHours] || 0,
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Global Cool Off Period(Hrs)',
		mapDataToValue: (data: any) => data[COL_NAMES.globalCoolOfPeriodInHours] || 0,
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Cool Off Period for Conversion(Hrs)',
		mapDataToValue: (data: any) => data[COL_NAMES.conversionCoolOfPeriodHours] || 0,
		maxWidth: 220
	}),
	CategoricalColumn({
		title: 'Min. Conversion Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.conversionMinWithdrawalLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Max. Conversion Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.conversionMaxWithdrawalLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Cool Off Period for withdrawal(Hrs)',
		mapDataToValue: (data: any) => data[COL_NAMES.withdrawalCoolOfPeriodHours] || 0,
		maxWidth: 220
	}),
	CategoricalColumn({
		title: 'Min. Withdrawal Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.minWithdrawalLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Max. Withdrawal Limit(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.maxWithdrawalLimit]?.toLocaleString('en-IN'),
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Max. Withdrawal Fee(₹)',
		mapDataToValue: (data: any) => data[COL_NAMES.withdrawalFeeMaxValue]?.toLocaleString('en-IN'),
		maxWidth: 200
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
